/**
 * 객체 설정 > 공통 Store
 *
 * @since 2018-06-12
 * @author kdydesign.kim
 */

import {ObjectSecProfileApiPrefix as objApiPrefix, CommonApiPrefix as cmnApiPrefix} from 'utils'
import {i18n} from '~/plugins/i18n'

// utils
import { parseJSON } from '~/utils/common' // TAMS
import {objectList} from 'objectList'
import {pcDownloadFile} from '~/utils/files'

const getObjectTypeInfo = (objectType) => {
  let addrType = void 0
  let version = void 0
  let zone = void 0

  if (objectType === 'webCategory') {
    addrType = 'webcategory'
  } else if (objectType === 'service') {
    addrType = 'service'
  } else if (objectType === 'serviceGroup') {
    addrType = 'service-group'
  } else if (objectType === 'time') {
    addrType = 'time'
  } else if (['address.device', 'address.device.object'].indexOf(objectType) >= 0) {
    addrType = 'device'
  } else if (objectType === 'address.device.group') {
    addrType = 'device-group'
  } else if (['address.user', 'address.user.user'].indexOf(objectType) >= 0) {
    addrType = 'user'
  } else if (objectType === 'address.user.group') {
    addrType = 'user-group'
  } else if (objectType === 'address.user.ipMappingGroup') {
    addrType = 'ipmapuser-group'
  } else if (objectType.indexOf('address.host') >= 0 || objectType.indexOf('address.group') >= 0 || objectType.indexOf('address.network') >= 0 || objectType.indexOf('address.domain') >= 0) {
    addrType = objectType.split('.')[1]
    if (/\.4/.test(objectType) || addrType === 'domain') {
      version = '4'
    } else if (/\.6/.test(objectType)) {
      version = '6'
    }
    if (/\.in/.test(objectType)) {
      zone = '1'
    } else if (/\.out/.test(objectType)) {
      zone = '2'
    } else if (/\.dmz/.test(objectType)) {
      zone = '3'
    }
  }
  return {addrType, version, zone}
}
// 추후 다른 파일로 뺄 것...
const getFormPcDownloadOfColumns = (objectType) => {
  let obj = {}
  if (objectType === 'webCategory') {
    obj = {
      predef: i18n.t('cmn.type'),
      name: i18n.t('op.objectSettings_label_webCategoryObj'),
      upper_cate_name: i18n.t('op.objectSettings_field_upperCategory'),
      mmbr_count: i18n.t('op.objectSettings_label_urlCount'),
      desc: i18n.t('cmn.description'),
      ref: i18n.t('cmn.usedCheck')
    }
  } else if (objectType === 'service') {
    obj = {
      name: i18n.t('op.objectSettings_label_serviceName'),
      prtc: i18n.t('cmn.protocol'),
      srv_cate: i18n.t('op.objectSettings_field_serviceType'),
      start_port: i18n.t('cmn.sourcePort'),
      srv_port: i18n.t('cmn.servicePort'),
      life_time: 'Lifetime',
      prio: i18n.t('cmn.priority'),
      desc: i18n.t('cmn.description'),
      ref: i18n.t('cmn.usedCheck')
    }
  } else if (objectType === 'serviceGroup') {
    obj = {
      name: i18n.t('op.objectSettings_label_serviceGroupName'),
      desc: i18n.t('cmn.description'),
      srv_name: i18n.t('op.objectSettings_label_serviceName'),
      prtc: i18n.t('cmn.protocol'),
      srv_type: i18n.t('op.objectSettings_field_serviceType'),
      source_port: i18n.t('cmn.sourcePort'),
      service_port: i18n.t('cmn.servicePort'),
      Lifetime: 'Lifetime',
      priority: i18n.t('cmn.priority'),
      obj_desc: i18n.t('cmn.objDesciption'),
      ref: i18n.t('cmn.usedCheck')
    }
  } else if (objectType === 'time') {
    obj = {
      name: i18n.t('op.objectSettings_label_timeObjName'),
      week: i18n.t('cmn.allWeek'),
      month: i18n.t('cmn.allMonth'),
      year: i18n.t('cmn.allYear'),
      prio: i18n.t('cmn.period'),
      desc: i18n.t('cmn.description'),
      ref: i18n.t('cmn.usedCheck')
    }
  } else if (/^address\.host/.test(objectType)) {
    obj = {
      zone: 'Zone',
      name: i18n.t('cmn.hostName'),
      ip_list: i18n.t('cmn.ipAddr'),
      desc: i18n.t('cmn.description'),
      ref: i18n.t('cmn.usedCheck')
    }
  } else if (/^address\.network/.test(objectType)) {
    obj = {
      zone: 'Zone',
      name: i18n.t('cmn.networkName'),
      ip_list: i18n.t('cmn.ipAddr'),
      desc: i18n.t('cmn.description'),
      ref: i18n.t('cmn.usedCheck')
    }
  } else if (/^address\.domain/.test(objectType)) {
    obj = {
      zone: 'Zone',
      name: i18n.t('op.objectSettings_label_domainObjName'),
      dmn_name: i18n.t('cmn.domainName'),
      ipv4: 'IPv4',
      ipv6: 'IPv6',
      desc: i18n.t('cmn.description'),
      ref: i18n.t('cmn.usedCheck')
    }
  } else if (/^address\.group/.test(objectType)) {
    obj = {
      zone: 'Zone',
      name: i18n.t('cmn.groupName'),
      // mmbr_obj: i18n.t('op.objectSettings_label_groupInObject'),
      desc: i18n.t('cmn.description'),
      object_type: i18n.t('cmn.objectType'), // 객체 타입
      object_name: i18n.t('cmn.objectName'), // 객체 명
      object_domain_name: i18n.t('cmn.domainName'), // 도메인 이름
      ip: i18n.t('cmn.ip'), // IP
      obj_desc: i18n.t('cmn.objDesciption'), // 객체 설명
      ref: i18n.t('cmn.usedCheck')
    }
  }
  const keys = Object.keys(obj)
  const result = []
  for (let i = 0, l = keys.length; i < l; i++) {
    result.push(obj[keys[i]])
  }
  return result.length === 0 ? '' : `columns=(${result.join(',')})`
}

const initColumnsFilter = () => {
  return {
    deviceColumn: []
  }
}

// TAMS
function getCompData () {
  return {
    fw_ref: false,
    fwv6_ref: false,
    grp_ref: false,
    vpn_ref: false,
    ips_ref: false,
    wf_ref: false,
    dlp_ref: false,
    filetype_ref: false,
    obj_type: ''
  }
}

export const state = () => ({
  objectList: [],
  selectTarget: void 0,
  columnsFilter: initColumnsFilter(),
  objectUsedPopUpComp: {
    objectData: void 0,
    component: void 0,
    // TAMS
    detailData: [],
    compData: getCompData()
  },
  globalZone: 1,
  objectType: '',
  groupType: '',
  searchCase: false,
  searchText: '',
  searchType: ['name'],
  multipleSelect: false
})

export const mutations = {
  resetColumnsFilter (state) {
    state.columnsFilter = initColumnsFilter()
  },
  setColumnsFilter (state, {key, value}) {
    if (_.get(state.columnsFilter, [key])) {
      state.columnsFilter[key] = value
    }
  },
  // 객체 목록 초기화
  resetObjectList (state) {
    state.objectList = Object.freeze(_.cloneDeep(objectList(i18n)))
  },

  // 객체 목록 설정
  setObjectList (state) {
    state.objectList = Object.freeze(_.cloneDeep(objectList(i18n)))
  },

  // 선택된 객체 형태(ipMapping, user .. 사용)
  setSelectTarget (state, data) {
    state.selectTarget = data
  },

  // 객체 상세 검색 조건 설정
  setObjectSearch (state, {keyword, searchType, lowerCase}) {
    state.searchText = keyword
    state.searchType = searchType
    state.searchCase = lowerCase
  },

  // 객체 상세 검색 조건 초기화
  resetObjectSearch (state) {
    state.searchText = ''
    state.searchType = ['name']
    state.searchCase = false
  },

  // 객체 설정의 모든 데이터 리스트 state 초기화
  resetAllObjectDataList (state, rootState) {
    const store = rootState.cm.objectSecProfile.object.objectSettings

    store.groupObject.groupDataList = []
    store.serviceObject.serviceObjectDataList = []
    store.timeObject.timeObjectDataList = []
    store.addressObject.addressObjectDataList = []
    store.applicationObject.appObjectDataList = []
    store.applicationObject.appSearchFilter = {
      appSearchCategory: [],
      appSearchTech: [],
      appSearchChar: [],
      appSearchTag: [],
      appSearchCountry: [],
      appSearchRisk: []
    }
    store.webObject.webObjectDataList = []
    store.webObject.urlDataList = []
  },

  // 객체 사용 여부 팝업 컴포넌트 전역 설정
  setObjectUsedPopUpComp (state, data) {
    state.objectUsedPopUpComp.component = data
  },

  // 객체 사용 여부 팝업 컴포넌트 타이틀 지정
  setObjectUsedPopUpCompData (state, data) {
    state.objectUsedPopUpComp.objectData = data
    // TAMS
    let ref = parseJSON(data.ref_info)
    if (typeof ref === 'object') {
      ref = _.mapValues(ref, (value, key) => {
        if (key !== 'obj_type') {
          return Boolean(value)
        }
        return value
      })
    }
    state.objectUsedPopUpComp.compData = _.assign(getCompData(), ref) // TAMS
  },

  // 객체 형태 설정
  setObjectType (state, data) {
    state.objectType = data
  },

  // 전역 zone 데이터 설정
  setGlobalZone (state, data) {
    state.globalZone = data
  },

  // 그룹 형태 설정
  setGroupType (state, data) {
    state.groupType = data
  },

  // 객체 Counting
  getObjectViewCnt (state, {objectType, length}) {
    const objectList = _.map(state.objectList, (obj) => {
      if (obj.key === 'address') {
        const setData = (child, dataLength) => {
          _.each(child, (o) => {
            if (o.key === objectType) {
              _.assign(o, {
                dataLength: dataLength,
                header: 'custom'
              })
            }

            if (_.has(o, 'children')) {
              setData(o.children, length)
            }
          })
        }

        if (_.has(obj, 'children')) {
          setData(obj.children, length)
        }

        return obj
      } else {
        if (obj.key === objectType) {
          obj = {
            ...obj,
            dataLength: length
          }
        }

        return obj
      }
    })

    state.objectList = Object.freeze(objectList)
  },

  // 객체 Counting 속성 삭제
  removeObjectViewCnt (state) {
    const objectList = _.map(state.objectList, (obj) => {
      if (obj.key === 'address') {
        const setData = (child) => {
          _.each(child, (o) => {
            delete o.dataLength

            if (_.has(o, 'children')) {
              setData(o.children)
            }
          })
        }

        if (_.has(obj, 'children')) {
          delete obj.dataLength

          setData(obj.children)
        }

        return obj
      } else {
        delete obj.dataLength

        return obj
      }
    })

    state.objectList = Object.freeze(objectList)
  },

  // 다중 선택 여부 설정
  setMultipleSelect (state, data) {
    state.multipleSelect = data
  },

  // 객체 사용 여부 상세 조회 데이터 설정
  // TAMS
  setUsedDetailData (state, data) {
    state.objectUsedPopUpComp.detailData = data
  },

  initObjectUsedPopUpComp (state) {
    state.objectUsedPopUpComp.objectData = void 0
    state.objectUsedPopUpComp.detailData = void 0
    state.objectUsedPopUpComp.compData = getCompData()
  },

  // TAMS
  // 객체 설정의 모든 선택된 데이터 state 초기화
  resetAllSelectedData (state, rootState) {
    const store = rootState.cm.objectSecProfile.object.objectSettings

    store.groupObject.selectedData = void 0
    store.serviceObject.selectedData = void 0
    store.timeObject.selectedData = void 0
    store.addressObject.selectedData = void 0
    store.applicationObject.selectedData = void 0
  }
}

export const actions = {
  // 객체 설정의 모든 데이터 리스트 state 초기화
  resetAllObjectDataList ({commit, rootState}) {
    commit('resetAllObjectDataList', rootState)
  },

  // 객체 Counting
  // isNotSelectedPrevent: 선택되지 않은 객체를 갱신을 못하도록 막는 옵션
  getObjectViewCnt ({commit, rootState, state}, {dataLength = 0, objectType, isNotSelectedPrevent = false}) {
    objectType = objectType || rootState.cm.objectSecProfile.object.objectSettings.common.objectType
    if (state.objectType !== objectType && isNotSelectedPrevent) {
      return
    }
    const length = dataLength

    // 객체 별 데이터 개수 설정
    commit('getObjectViewCnt', {objectType, length})
  },

  // 주소 객체 zone 설정
  setGlobalZone ({commit}, {zone}) {
    let tmpZone = zone

    // TAMS (0 예외처리)
    if (tmpZone === null || tmpZone === 0) {
      tmpZone = 1
    }

    commit('setGlobalZone', tmpZone)
    commit('cm/objectSecProfile/object/objectSettings/addressObject/setZone', tmpZone, {root: true})
    commit('cm/objectSecProfile/object/objectSettings/groupObject/setZone', tmpZone, {root: true})
  },

  // 객체 일괄 배치 처리대상의 파일 업로드
  async batchUpload ({commit, state}, {formData}) {
    const uri = `${cmnApiPrefix}/file/import`
    const {code, result} = await this.$axios.$post(uri, formData, {isNotAlert: true})

    if (code === 'ok') {
      return result
    }
  },

  // 업로드 결과 값으로 객체 일괄 배치 처리
  async executeBatch ({commit, state, rootState, dispatch}, {file, allow_dup = false, isUrl = false}) {
    const objectType = state.objectType
    let {addrType, version} = getObjectTypeInfo(objectType)

    let uri = `${objApiPrefix}/${addrType}`

    if (version) {
      uri += `/${version}`
    }
    if (isUrl) {
      const pid = _.get(rootState, ['cm', 'objectSecProfile', 'object', 'objectSettings', 'webObject', 'selectedData', 'web_cate_obj_id']) // TAMS
      uri += `/objects/${pid}/urls/batch`
    } else {
      uri += '/objects/batch'
    }
    const {code, result} = await this.$axios.$post(uri, {file, allow_dup})
    if (code === 'async') {
      dispatch('common/common/setIsChanged', true, {root: true})
    }

    return {code, result}
  },

  // PC로 파일 다운로드
  async pcDownload ({commit, state}, {objectType}) {
    let {addrType, version, zone} = getObjectTypeInfo(objectType)

    let uri = `${objApiPrefix}/${addrType}`

    if (version) {
      uri += `/${version}`
    }

    uri += '/objects/save'

    if (zone) {
      uri = uri.concat(`?q=zone=${zone}`)
    }

    const columns = getFormPcDownloadOfColumns(objectType)
    if (columns) {
      uri += zone ? `&${columns}` : `?${columns}`
    }

    const {data, fileName} = await this.$axios.$file(uri, {responseType: 'blob'})
    pcDownloadFile(data, fileName)
  },

  getColumnsFilter ({state, commit}) {
    const filters = Object.keys(state.columnsFilter)
    for (let i = 0, l = filters.length; i < l; i++) {
      const filterKey = filters[i]
      const filterStr = localStorage.getItem(filterKey)
      if (filterStr) {
        commit('setColumnsFilter', {key: filterKey, value: JSON.parse(filterStr)})
      }
    }
  },

  // TAMS
  // 객체 설정의 모든 선택된 리스트 초기화
  resetAllSelectedData ({commit, rootState}) {
    commit('resetAllSelectedData', rootState)
  },

  // TAMS
  async getObjectRefDetailData ({state, commit}, {funcType, objType, objId}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const params = {
        func_type: funcType,
        obj_type: objType,
        obj_id: objId
      }
      res = await this.$axios.$post(`/api/op/obj_ref_detail`, params, {
        successAlert: false
      })
      if (res.code === 'ok') {
        commit('setUsedDetailData', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {
  // 객체 목록 list, tree 형태 분리
  objectList (state) {
    const objectList = [],
      objectTreeList = []

    _.find(state.objectList, (obj) => {
      // obj = generateObjectByFeature(rootState, obj) // TAMS 제외
      if (obj) {
        if (!obj.children) {
          objectList.push(obj)
        } else {
          objectTreeList.push(obj)
        }
      }
    })

    return {
      list: objectList,
      treeNode: objectTreeList
    }
  },

  // 객체 별 데이터 총 개수 조회
  totalDataCount (state, getters, rootState) {
    const objectType = state.objectType

    if (objectType === 'application') {
      const appObjectDataList = rootState.cm.objectSecProfile.object.objectSettings.applicationObject.appObjectDataList
      return appObjectDataList.length
    } else if (objectType === 'service') {
      const serviceObjectDataList = rootState.cm.objectSecProfile.object.objectSettings.serviceObject.serviceObjectDataList
      return serviceObjectDataList.length
    } else if (objectType === 'time') {
      const timeObjectDataList = rootState.cm.objectSecProfile.object.objectSettings.timeObject.timeObjectDataList
      return timeObjectDataList.length
    } else if (objectType === 'serviceGroup') {
      const serviceGroupDataList = rootState.cm.objectSecProfile.object.objectSettings.groupObject.groupDataList
      return serviceGroupDataList.length
    } else if (objectType && objectType.indexOf('address') > -1) {
      const addressObjectDataList = rootState.cm.objectSecProfile.object.objectSettings.addressObject.addressObjectDataList
      return addressObjectDataList.length
    } else {
      return 0
    }
  }
}

export const strict = false
